import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DASH_DEFAULT_SECTIONS, DASH_SECTION_KEYS, DashboardConfig } from '../models/dashboard-config.model';

@Injectable({ providedIn: 'root' })
export class DashboardConfigService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiBaseUrl}/api/v1/users/me/dashboard-config`;

  getConfig(): Observable<DashboardConfig> {
    return this.http.get<DashboardConfig>(this.apiUrl);
  }

  saveConfig(config: DashboardConfig): Observable<DashboardConfig> {
    return this.http.put<DashboardConfig>(this.apiUrl, config);
  }

  resetConfig(): Observable<DashboardConfig> {
    return this.http.delete<DashboardConfig>(this.apiUrl);
  }

  defaultConfig(): DashboardConfig {
    return { sections: { ...DASH_DEFAULT_SECTIONS }, vonDatum: null, bisDatum: null, projectIds: [], isDefault: true };
  }

  isDefault(config: DashboardConfig): boolean {
    if (config.vonDatum !== null || config.bisDatum !== null) return false;
    if (config.projectIds.length > 0) return false;
    return DASH_SECTION_KEYS.every((key) => config.sections[key] === DASH_DEFAULT_SECTIONS[key]);
  }
}
